import React, { useRef, useState, useEffect } from 'react';
import { Box, Tab, Tabs, IconButton } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';

const TabsFilterHR = ({ tabValue, setTabValue, data }) => {
  const tabLabels = ['All', 'Pending', 'Approved', 'Rejected'].map(label => {
    let count;
    if (label === 'All') {
      count = data?.length || 0;
    } else {
      count = data?.filter(request => request.hrStatus?.toLowerCase() === label.toLowerCase()).length || 0;
    }
    return `${label} (${count})`;
  });

  const tabsContainerRef = useRef(null);
  const [showScrollButtons, setShowScrollButtons] = useState(false);

  const scroll = direction => {
    if (tabsContainerRef.current) {
      const scrollAmount = direction === 'left' ? -100 : 100;
      tabsContainerRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  const updateScrollButtonsVisibility = () => {
    if (tabsContainerRef.current) {
      const { scrollWidth, clientWidth, scrollLeft } = tabsContainerRef.current;
      setShowScrollButtons(scrollWidth > clientWidth);
    }
  };

  useEffect(() => {
    updateScrollButtonsVisibility();
    window.addEventListener('resize', updateScrollButtonsVisibility);
    return () => window.removeEventListener('resize', updateScrollButtonsVisibility);
  }, [data]);

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        overflowX: 'auto',
        display: 'flex',
        alignItems: 'center',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
        '@media (max-width: 600px)': {
          overflowX: 'auto',
          '&::-webkit-scrollbar': {
            display: 'block',
            width: '8px',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
            borderRadius: '4px',
          },
        },
      }}
    >
      <IconButton
        sx={{
          position: 'absolute',
          top: '50%',
          left: 0,
          transform: 'translateY(-50%)',
          zIndex: 1,
          display: showScrollButtons ? 'block' : 'none',
          backgroundColor: 'white',
        }}
        onClick={() => scroll('left')}
      >
        <ChevronLeft />
      </IconButton>
      <Tabs
        value={tabValue}
        onChange={(event, newValue) => setTabValue(newValue)}
        aria-label='Request Status'
        variant='scrollable'
        scrollButtons='auto'
        sx={{
          flexWrap: 'nowrap',
          overflowX: 'auto',
          '& .MuiTabs-scrollable': {
            overflowX: 'auto',
            flexWrap: 'nowrap',
          },
          '& .MuiTab-root': {
            minWidth: 'auto',
            fontSize: {
              xs: '0.75rem',
              sm: '0.875rem',
              // md: '1rem',
              // lg: '1.125rem',
              // xl: '1.25rem',
            },
            px: {
              xs: 1,
              sm: 2,
              md: 3,
            },
          },
        }}
        ref={tabsContainerRef}
      >
        {tabLabels.map((label, index) => {
          const [text, count] = label.split(/\(([^)]+)\)/);
          return (
            <Tab
              key={index}
              label={
                <span>
                  {text}
                  <span
                    style={{
                      backgroundColor: count
                        ? text.includes('All')
                          ? 'rgba(15, 7, 17, 0.09)'
                          : text.includes('Pending')
                          ? 'rgba(255, 193, 7, 0.16)'
                          : text.includes('Approved')
                          ? 'rgba(84, 214, 44, 0.16)'
                          : text.includes('Rejected')
                          ? 'rgba(255, 72, 66, 0.16)'
                          : 'inherit'
                        : 'inherit',
                      padding: '2px 8px',
                      borderRadius: '4px',
                    }}
                  >
                    {count}
                  </span>
                </span>
              }
              sx={{ color: 'grey' }}
            />
          );
        })}
      </Tabs>
      <IconButton
        sx={{
          position: 'absolute',
          top: '50%',
          right: 0,
          transform: 'translateY(-50%)',
          zIndex: 1,
          display: showScrollButtons ? 'block' : 'none',
          backgroundColor: 'white',
        }}
        onClick={() => scroll('right')}
      >
        <ChevronRight />
      </IconButton>
    </Box>
  );
};

export default TabsFilterHR;
